<script>
import appConfig from "@/app.config"
import Layout from "@/views/layouts/main"
import PageHeader from "@/components/page-header"
import atendimentoController from "@/controller/AtendimentoController"
import { http } from "@/helpers/easyindustriaapi/config"
import Swal from "sweetalert2"

export default {
    page: {
        title: "Relatório de Atendimentos por Profissional",
        meta: [
        {
            name: "description",
            content: appConfig.description,
        },
        ],
    },
    name: 'RepasseProfissionais',
    components: { PageHeader, Layout },
    data() {
        return {
            listaAtendimentos: [],
            listaProfissionais: [],
            professional: null,
            toggleRecurrences: false,
            titleBody: "Relatório de Repasses",
            filter: "",
            perPage: 10,
            currentPage: 1,
            rows: 0,
            pageOptions: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            items: [
                {
                    text: "Atendimentos",
                    href: "/atendimentos",
                    active: true,
                },
                {
                text: "Relatório de Repasses",
                href: "/relatorios/atendimentos/RepasseProfissionais",
                },
            ],
            fildes: [
                { key: "show_details", label: "", tdClass: "text-center" },
                { key: "paciente", label: "Paciente", sortable: true, tdClass: 'text-left', thClass: 'text-center' },
                { key: "quantidade", label: "Quantidade", sortable: true, tdClass: 'text-right', thClass: 'text-center' },
                { key: "total", label: "SubTotal", sortable: true, tdClass: 'text-right', thClass: 'text-center' },
            ],
        }
    },
    created() {
        this.currentCompany = JSON.parse(localStorage.getItem("currentEmpresa"))
        this.currentUser    = JSON.parse(localStorage.getItem("user"))
        this.atendimentoController = new atendimentoController(this.currentUser, this.currentEmpresa)
    },
    mounted() {
        this.getProfessionais(this.axiosParams)
    },
    computed: {
        totalQuantidade() {
            return this.listaAtendimentos.reduce((acc, item) => acc + Number(item.quantidade || 0), 0)
        },
        totalValor() {
            return this.listaAtendimentos.reduce((acc, item) => acc + item.total, 0)
        },
        axiosParams() {
            console.log(this.professional)
            const params = new URLSearchParams();
            params.append("empresa_id", this.currentCompany.id);

            if (this.professional) {
              params.append("professional_id", this.professional);
            }

            return params;
        }        
    },
    methods: {
        onProfessionalChange() {
            console.log(this.professional)
            console.log(this.axiosParams)
            this.getAtendimentos(this.axiosParams)
        },
        getProfessionais() {
            // Exibe o SweetAlert com loader
            Swal.fire({
                title: 'Aguarde...',
                text: 'Carregando dados...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
                }
            });
            const promisse = http.get(`/professional?empresa_id=${this.currentCompany.id}`)
            promisse.then((res) => {
                if (res.status == 200)
                {
                    this.listaProfissionais = res.data
                }
            }).finally(() => {
                Swal.close()
            })
        },
        getAtendimentos(axiosParams) {
            const promisse = http.get(`atendimento/calcularValorTotalRealizado`, { params: axiosParams })
            promisse.then((res) => {
                if (res.status == 200)
                {
                    this.listaAtendimentos = res.data.atendimentos
                    this.listaProfissionais = res.data.professionals
                }
            })
        },
        showToggleRecuerences() {
            this.toggleRecurrences = !this.toggleRecurrences
        },
    },
}
</script>
<template>
    <Layout>
        <PageHeader :title="titleBody" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <b-tabs nav-class="nav-tabs-custom">
                            <b-tab title-link-class="p-3">
                                <template v-slot:title>
                                  <a class="font-weight-bold active" @click="getAtendimentos">Listagem</a>
                                </template>
                                <div class="row mt-4">
                                    <div class="col-sm-12 col-md-6">
                                        <h4 class="card-title">Fitros</h4>
                                        <b-form-group label="Profissional">
                                            <b-form-select
                                                v-model="professional"
                                                :options="listaProfissionais"
                                                @change="onProfessionalChange"
                                                text-field="name"
                                                value-field="id"
                                            />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-sm-12 col-md-6">
                                        <div id="tickets-table_length" class="dataTables_length">
                                            <label class="d-inline-flex align-items-center">
                                                Ver&nbsp;
                                                <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                                            </label>
                                        </div>
                                    </div>
                                    <!-- Search -->
                                    <div class="col-sm-12 col-md-6">
                                        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                        <label class="d-inline-flex align-items-center col-sm-12">
                                            Pesquisar:
                                            <b-form-input
                                            v-model="filter"
                                            type="search"
                                            class="form-control form-control-sm ml-2"
                                            ></b-form-input>
                                        </label>
                                        </div>
                                    </div>
                                    <!-- End search -->
                                </div>
                                <div class="table-responsive">
                                    <div class="row" v-if="!(listaAtendimentos.length > 0)">
                                        <div class="col-sm-12 col-md-6">
                                            <div id="tickets-table_info" class="dataTables_info">
                                                Selecione um profissional para visualizar os atendimentos realizados.
                                            </div>
                                        </div>
                                    </div>
                                    <b-table
                                        v-if="listaAtendimentos.length > 0"
                                        class="table-centered table-striped"
                                        responsive="sm"
                                        :per-page="perPage"
                                        :filter="filter"
                                        :items="listaAtendimentos"
                                        :fields="fildes"
                                        :show-details="true"
                                        @row-toggle-details="showToggleRecuerences"
                                        foot-clone
                                    >
                                        <template #cell(paciente)="data">
                                            <span class="text-truncate d-block font-size-14">
                                                {{ data.item.paciente }}
                                            </span>
                                        </template>
                                        <template #cell(show_details)="row">
                                            <b-button
                                                v-if="row.detailsShowing"
                                                size="lg"
                                                @click="row.toggleDetails"
                                                variant="outline-light"
                                            >
                                                <i class="bx ri-toggle-fill"></i>
                                            </b-button>
                                            <b-button
                                                v-else
                                                size="lg"
                                                @click="row.toggleDetails"
                                                variant="outline-light"
                                            >
                                                <i class="bx ri-toggle-line"></i>
                                            </b-button>
                                        </template>
                                        <template #row-details="row">
                                            <b-card class="border border-danger">
                                                <b-card-body
                                                    v-for="rec in row.item.recurrences"
                                                    :key="rec.id"
                                                >
                                                    <h5 class="card-title">{{  rec.agenda.professional.name }}</h5>
                                                    <!-- `rec.desc` vem do CKEditor e pode conter HTML (ex.: <img>). -->
                                                    <p
                                                        class="card-text"
                                                        v-if="rec.desc"
                                                        v-html="rec.desc"
                                                    ></p>
                                                    <p v-else class="card-text"></p>
                                                    <p class="card-text small text-muted">
                                                        <i class="bx ri-calendar-2-line"></i>{{ rec.end }} {{ rec.end_time }}
                                                    </p>
                                                </b-card-body>
                                            </b-card>
                                        </template>
                                        <template #cell(total)="data">
                                            <span class="text-truncate d-block font-size-14">
                                                <div class="text-right">
                                                        {{ formatterCurrBR(data.item.total) }}
                                                </div>
                                            </span>
                                        </template>
                                        <!-- Footer -->
                                        <template #foot(paciente)>
                                        </template>
                                        <template #foot(quantidade)>
                                            <strong>{{ totalQuantidade }}</strong>
                                        </template>
                                        <template #foot(total)>
                                            <strong>{{ formatterFloatBR(totalValor) }}</strong>
                                        </template>
                                    </b-table>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="dataTables_paginate paging_simple_numbers float-right">
                                            <ul class="pagination pagination-rounded mb-0">
                                                <!-- pagination -->
                                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>